import axios from 'axios';

// Constants.
import * as ConsentsConstants from 'constants/ConsentsConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

function requestLoadUserConsents() {
  return {
    type: ConsentsConstants.LOAD_CONSENTS_REQUEST,
  };
}

function receiveLoadUserConsents(consents) {
  return {
    type: ConsentsConstants.LOAD_CONSENTS_SUCCESS,
    consents,
  };
}

function receiveLoadUserConsentsError(response) {
  return {
    type: ErrorConstants.LOAD_REQUEST_FAILURE,
    response,
  };
}

function requestUpdateUserConsents() {
  return {
    type: ConsentsConstants.UPDATE_CONSENTS_REQUEST,
  };
}

function receiveUpdateUserConsents(consents) {
  return {
    type: ConsentsConstants.UPDATE_CONSENTS_SUCCESS,
    consents,
  };
}

function receiveUpdateUserConsentsError(response) {
  return {
    type: ErrorConstants.LOAD_REQUEST_FAILURE,
    response,
  };
}

export function loadUserConsents() {
  return (dispatch) => {
    dispatch(requestLoadUserConsents());
    axios({
      method: 'GET',
      url: '/api/v2/consents/',
    })
      .then((response) => {
        const consents = response.data;
        dispatch(receiveLoadUserConsents(consents));
      })
      .catch((error) => {
        dispatch(receiveLoadUserConsentsError(error.response));
      });
  };
}

export function updateUserConsents(consents) {
  return (dispatch) => {
    dispatch(requestUpdateUserConsents());
    axios({
      method: 'POST',
      url: '/api/v2/consents/',
      data: {
        consents
      }
    })
      .then((response) => {
        dispatch(receiveUpdateUserConsents(consents));
      })
      .catch((error) => {
        dispatch(receiveUpdateUserConsentsError(error.response));
      });
  };
}
